export enum DateTimeType {
    DateOnly,
    TimeOnly,
    DateTime
}